import HeadingSecondary from "../components/ HeadingSecondary";
import appBg from "../assets/images/app-bg.png";
import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import QrReader from "react-qr-reader";
import AlertMessage from "../components/AlertMessage";

import "react-toastify/dist/ReactToastify.css";
import { logOut } from "../helper/helper";

import profileService from "../services/profile.service";

import DotLoading from "../components/DotLoading";
import ScanHealthUserInfoBottomSheet from "../components/ScanHealthUserInfoBottomSheet";

export let activePermission = false;
const SettingUserInquiry: React.FC<any> = () => {
  // eslint-disable-next-line
  const [scanResultWebCam, setScanResultWebCam] = useState("");
  const [showQrReader, setShowQrReader] = useState(false);
  const [showAlertPrimary, setShowAlertPrimary] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  // eslint-disable-next-line
  const [showGuildBottomSheet, setShowGuildBottomSheet] = useState(false);
  // eslint-disable-next-line
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [scanHealthUserInfo, setScanHealthUserInfo] = useState({
    firstName: "",
    lastName: "",
    nationalId: "",
    birthDate: "",
    covidStatus: "",
    receiptDate: "",
    numberOfDozes: "",
    vaccineHistory: [],
  }) as any;

  const [showUserHealthBottomSheet, setShowUserHealthBottomSheet] = useState(false);
  const onDismiss = () => {
    setShowUserHealthBottomSheet(false);
  };
  const isMounted = React.useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  type UserInquiryForm = {
    codeRef: string;
  };
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<UserInquiryForm>();

  const scanHealthUserInfoByQrCode = async (code: any) => {

    try {
      setLoading(true);
      const { data } = await profileService.scanHealthUserInfoByQrCode(code);

      if (isMounted.current) {

        // console.log('http://192.168.43.16:3000/' + "?userHealthQrCode=" + data.qrCode);

        // local test "http://192.168.43.16:3000/profile" + "?" + userHealthQrCodeParam + "=" + data.qrCode,

        // stage test  window.location.href + "?" + userHealthQrCodeParam + "=" + data.qrCode,
        // let birthDate = data.birthDate;
        setScanHealthUserInfo({
          firstName: data.firstName,
          lastName: data.lastName,
          nationalId: data.nationalId,
          // birthDate: birthDate.slice(0, 4) + "/" + birthDate.slice(4, 6) + "/" + birthDate.slice(6),
          covidStatus: data.status ? data.status : "UNKNOWN",
          receiptDate: data.receiptDate,
          vaccineHistory: data.vaccineHistory === null ? [] : data.vaccineHistory,
          // numberOfDozes: data.numberOfDozes ? parseInt(data.numberOfDozes) : 0,
        });
        setShowUserHealthBottomSheet(true);
      }
    } catch (error: any) {
      // alert(error);
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 401) {
          logOut();
        }
        if (error.response.status === 400) {
          logOut();
        }

        if (error.response.status === 404) {
          setError("codeRef", {
            type: "server",
            message: "کد اشتباه میباشد، لطفا دوباره امتحان کنید.",
          });
        }

        if (error.response.status === 500) {
          setError("codeRef", {
            type: "server",
            message: "خطا در سرور",
          });
        }
        // console.log(error.response.data);
        console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (formData: UserInquiryForm, e: any) => {

    scanHealthUserInfoByQrCode(formData.codeRef);
    reset();
  };

  // useEffect(() => {
  //   if (scanResultWebCam !== "") {
  //     setShowGuildBottomSheet(true);
  //   }
  // }, [scanResultWebCam]);
  const handleScanWebCam = (result: any) => {
    if (result) {
      // alert(result);
      document.querySelector(".qr-reader > section > div")!.classList.add("green-qr");
      setScanResultWebCam(result);
      setShowQrReader(false);
      window.location.href = result;
      // window.location.replace(result);
    }
  };

  const handleErrorWebCam = (error: any) => {
    console.log(error);
  };

  const handleShowQrReader = () => {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        // @ts-ignore
        .query({ name: "camera" })
        .then(function (result) {
          // alert(result.state);
          if (result.state === "granted") {
            setShowQrReader(false);
            setShowQrReader(true);
            return false;
            //permission has already been granted, no prompt is shown
          } else if (result.state === "prompt") {
            setShowAlertPrimary(true);
            // if (window.confirm("نیاز به دسترسی دوربین")) {
            //   setShowQrReader(true);
            // }
            return false;
            //there's no peristent permission registered, will be showing the prompt
          } else if (result.state === "denied") {
            setShowAlertMessage(true);
            return false;
            // window.confirm(
            //   "برای خواندن تصویر کیوآٰرکد دسترسی به دوربین لازم است . لطفا از بخش تنظیمات دسترسی به دوربین را فعال کنید."
            // );
          }
        })
        .catch((e) => {
          setShowQrReader(true);
        });
    } else {
      setShowQrReader(true);
    }
  };

  const closeAlertPrimary = (e: any) => {
    if (alertPrimaryRef.current === e.target) {
      setShowAlertPrimary(false);
      return false;
    }
  };

  const handleActivePermission = (e: any, param: string) => {
    if (param === "ok") {
      setShowAlertPrimary(false);
      setShowQrReader(true);
      return true;
    }
    setShowAlertPrimary(false);
    return false;
  };

  const alertPrimaryRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <ScanHealthUserInfoBottomSheet
        showUserHealthBottomSheet={showUserHealthBottomSheet}
        onDismiss={onDismiss}
        scanHealthUserInfo={scanHealthUserInfo}
        loading={loading}
      />
      <div
        className="alert-primary"
        id="alert-primary"
        onClick={closeAlertPrimary}
        ref={alertPrimaryRef}
        style={{ maxHeight: `${showAlertPrimary ? "100%" : "0%"}` }}
      >
        <div
          className="alert-primary__permission"
          style={{ maxHeight: `${showAlertPrimary ? "100%" : "0%"}` }}
        >
          <h6>دسترسی به دوربین</h6>
          <p>
            برای خواندن QR کد نیاز به دسترسی دوربین میباشد.بعد از گزینه فعال کردن دکمه allow را
            بزنید.
          </p>
          <div className="alert-primary__btn-gp">
            <button
              className="btn btn--anchor u-width-49 u-d-flex u-justify-content-center u-align-item-center"
              onClick={(event) => handleActivePermission(event, "nok")}
            >
              الان نه
            </button>
            <button
              className="btn btn--primary small u-width-49"
              onClick={(event) => handleActivePermission(event, "ok")}
            >
              فعال کردن
            </button>
          </div>
        </div>
      </div>

      <AlertMessage
        title="دسترسی به دوربین"
        body="در بخش تنظیمات یا مرورگر خود دسترسی به دوربین را فعال کنید."
        btn="متوجه شدم"
        onShowAlertMessage={showAlertMessage}
        onSetShowAlertMessage={setShowAlertMessage}
      />

      <div className="setting">
        <div className="u-margin-top-small-3 u-margin-bottom-small-2">
          <HeadingSecondary text="شهروندان" />
        </div>

        <div className="guild__inquiry u-margin-bottom-small-3 u-width-100">
          <p className="guild__inquiry__title">استعلام وضعیت سلامت شهروندان</p>
          <p className="guild__inquiry__text u-text-right">
            دوربین تلفن همراه خود را به سمت QR کد پروفایل شهروندی مورد نظر بگیرید
          </p>
          {showQrReader ? (
            <QrReader
              className="qr-reader"
              delay={300}
              style={{ width: "100%" }}
              onError={handleErrorWebCam}
              onScan={handleScanWebCam}
            />
          ) : (
            <img src={appBg} alt="app bg" />
          )}
          {/*<p>{scanResultWebCam}</p>*/}
          <div className="u-width-100 u-margin-center-auto u-margin-top-small-2">
            <button className="btn btn--primary medium" onClick={handleShowQrReader}>
              <span>اسکن QR کد</span>
            </button>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={`guild__inquiry__input-container ${errors.codeRef ? "input-error" : ""}`}
              >
                <input
                  type="text"
                  className="guild__inquiry__input-container--element"
                  placeholder="ورود شناسه QR کد"
                  {...register("codeRef", {
                    required: true,
                    minLength: {
                      value: 5,
                      message: "Too Many Characters",
                    },
                  })}
                />
                <button
                  className="btn btn--primary guild__inquiry__input-container--btn"
                  type={`${loading ? "button" : "submit"}`}
                >
                  {loading ? <DotLoading /> : "استعلام"}
                </button>
              </div>
              <div className="error-box u-margin-top-small-1 u-text-right u-ltr">
                {errors.codeRef && errors.codeRef.type === "required" && (
                  <p className="error-box__content u-text-right u-rtl">
                    پر کردن این فیلد الزامی است .
                  </p>
                )}
                {errors.codeRef && errors.codeRef.type === "minLength" && (
                  <p className="error-box__content u-text-right u-rtl">تعداد حروف کوتاه است.</p>
                )}
                {errors.codeRef && errors.codeRef.type === "server" && (
                  <p className="error-box__content u-text-right u-rtl">{errors.codeRef.message}</p>
                )}
                {/* {singleGuildError && <p className="error-box__content">{singleGuildError}</p>} */}
                {/* <p className="error-box__content u-text-right u-ltr">
                  . شناسه وارد شده صحیح نیست، مجددا تلاش بفرمایید
                </p> */}
              </div>
            </form>
          </div>
        </div>
        <div className="setting__userinquiry__text u-margin-bottom-big">
          <p>
            از طریق این بخش میتوانید ضمن امکان استعلام QR شهروندان از طریق دوربین تلفن همراه یا ورود
            شناسه QR کد مندرج در زیر QR کد شهروندان اقدام به انجام استعلام نمایید .
          </p>
        </div>
      </div>
    </>
  );
};

export default SettingUserInquiry;
